import axios from "axios";
import { URLS } from "./urls";

export const getSystemAnnouncementDetails = () => axios.get(URLS.GET_SYSTEM_ANNOUNCEMENT_DETAILS);
export const updateSystemAnnouncementByKey = (data) => axios.post(URLS.UPDATE_SYSTEM_ANNOUNCEMENT_BY_KEY,data);
export const getActiveSystemAnnouncements = (app) =>axios.get(`${URLS.GET_ACTIVE_SYSTEM_ANNOUNCEMENTS}?app=${app}`);

